/* eslint-disable react/destructuring-assignment */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useCallback } from 'react';
import { Redirect } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import get from 'lodash/get';
import { selectErrorMessage, selectRedirect, selectShowGridViewContext, selectShowModalAssignUsers } from 'store/Workspace/selectors';
import { selectCurrentWorkspace } from 'store/Faraday/selectors';
import { stopRedirect, loadWorkspaceDetail, hideWorkspaceDetail, getUsers, resetError, resetState } from 'Screens/Contextualization/Workspaces/actions/Actions';
import { resetFiltersExceptOrderBy } from 'store/Filters/actions';
import Table from './components/Table';
import WSActionBar from './components/WSActionBar';
import Wrapper from './styled';
import GridView from './components/GridView';
import { EEFeatureSlot } from 'Common/ee/EEFeatureSlot';
import ReduxModal from 'Common/Components/ReduxModal';
import { MODAL_UPGRADE_LICENSE, MODAL_WORKSPACE_CREATE, MODAL_WORKSPACE_GROUPING_CONFIRM } from 'store/modals/modals';
import UpgradeLicense from 'Common/Components/UpgradeLicense';
import upgradeLicenseImage from 'Images/workspaces-license.png';
import { ACTIONS } from 'tracking/GA/constants';
import { getEESelector } from 'Common/ee/registry';
import DeactivateConfirmationModal from './components/GridView/components/ DeactivateConfirmationModal';
import ModalCreation from './components/ModalCreation';
import selectModal from 'store/modals/selectors';
import { closeModal } from 'store/modals/actions';
import { SidebarTour } from 'Common/Components/Tour';
import { getVulnsCountInAllWorkspaces } from 'Screens/Contextualization/Faraday/actions/Actions';
import { selectIsLoggedIn } from 'store/Sesion/selectors';
import ErrorDialog from 'Common/Components/ErrorDialog';
import UpdateModal from './components/WorkspaceDetail/components/Header/Title/UpdateModal';
import { selectWsEditCreateErrorMessage } from 'store/WorkspaceEditCreate/selectors';
import Modal from 'Common/Components/Modal';

const WorkspaceContext = ({ params }) => {
  const dispatch = useDispatch();
  const currentWorkspace = useSelector(selectCurrentWorkspace);
  const redirect = useSelector(selectRedirect);
  const showGridView = useSelector(selectShowGridViewContext);
  const showModalAssignUsers = useSelector(selectShowModalAssignUsers);
  const allowGetUsers = useSelector(getEESelector('allow-get-users', () => false));
  const [showConfirmation, setShowConfirmation] = useState({ show: false, ws: '', isMassive: false, active: false });
  const showModalCreateWs = useSelector((state) => selectModal(state, MODAL_WORKSPACE_CREATE));
  const isLoggedIn = useSelector(selectIsLoggedIn);
  const handleClose = () => dispatch(closeModal(MODAL_WORKSPACE_CREATE));
  const workspaceErrorMessage = useSelector(selectErrorMessage);
  const wsCreateErrorMessage = useSelector(selectWsEditCreateErrorMessage);
  const errorMessage = workspaceErrorMessage || wsCreateErrorMessage;

  const handleParamWsName = useCallback(() => {
    const wsName = get(params, 'wsname', '');
    if (wsName) {
      dispatch(loadWorkspaceDetail(wsName));
    } else {
      dispatch(hideWorkspaceDetail());
    }
  }, [params]);

  useEffect(() => {
    if (allowGetUsers && isLoggedIn) dispatch(getUsers());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allowGetUsers, dispatch, setShowConfirmation]);

  useEffect(() => {
    if (isLoggedIn) dispatch(getVulnsCountInAllWorkspaces());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  useEffect(() => {
    handleParamWsName();
  }, [handleParamWsName]);

  useEffect(() => () => {
    dispatch(resetState());
    dispatch(resetFiltersExceptOrderBy('workspaces'));
  }, [dispatch]);

  if (redirect) {
    dispatch(stopRedirect());
    return <Redirect to={ `/manage/${currentWorkspace}` } />;
  }

  return (
    <Wrapper>
      <WSActionBar setShowConfirmation={ setShowConfirmation } />
      {showGridView
        ? <GridView setShowConfirmation={ setShowConfirmation } />
        : <Table setShowConfirmation={ setShowConfirmation } />
      }
      {showConfirmation.show ? <DeactivateConfirmationModal onCloseCallback={ () => setShowConfirmation({ show: false, name: '', isMassive: false }) } show={ showConfirmation.show } ws={ showConfirmation.ws } isMassive={ showConfirmation.isMassive } active={ showConfirmation.active } /> : null}
      {showModalAssignUsers && <EEFeatureSlot featureKey="modal-assign-users" />}
      <ReduxModal id={ MODAL_UPGRADE_LICENSE }>
        <UpgradeLicense id={ MODAL_UPGRADE_LICENSE } image={ upgradeLicenseImage } descriptionIntlId="upgradeLicense.workspace.description" trackingShow={ ACTIONS.showWorkspace } trackingClick={ ACTIONS.clickWorkspaces } />
      </ReduxModal>
      <ReduxModal id={ MODAL_WORKSPACE_GROUPING_CONFIRM }>
        <Modal />
      </ReduxModal>
      {showModalCreateWs && <ModalCreation handleClose={ handleClose } />}
      <SidebarTour />
      <EEFeatureSlot
        featureKey="workspaces-risk-profiles-tour"
        render={ (RiskProfilesTourLauncher) => <RiskProfilesTourLauncher /> }
        fallback={ null }
      />
      {!!errorMessage && (
        <ErrorDialog
          message={ errorMessage }
          resetError={ () => dispatch(resetError()) }
        />
      )}
      <UpdateModal />
    </Wrapper>
  );
};

export default WorkspaceContext;
